var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 139,
    height: 139,
    viewBox: "0 0 139 139",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Linkedin",
    transform: "translate(-754.665 -402.964)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_45",
    "data-name": "Ellipse 45",
    cx: 67.5,
    cy: 67.5,
    r: 67.5,
    transform: "translate(756.665 404.964)",
    fill: "none",
    stroke: "#6cd7bb",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_126",
    "data-name": "Group 126"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_125",
    "data-name": "Group 125"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_147",
    "data-name": "Path 147",
    d: "M829.388,463.255c1.109-1.246,2.022-2.51,3.161-3.583a17.339,17.339,0,0,1,12.475-4.922,28.836,28.836,0,0,1,7.844.955c5.859,1.694,9.264,5.727,10.887,11.45a47.911,47.911,0,0,1,1.45,13.119c.016,9.324-.027,18.649-.007,27.973,0,.873-.243,1.1-1.1,1.1q-7.206-.06-14.411,0c-.845.007-1.028-.255-1.025-1.053q.04-13.308.005-26.617a23.921,23.921,0,0,0-.773-6.608c-1.149-3.982-4-6.011-8.172-5.791-5.7.3-8.658,3.121-9.385,8.914a33.268,33.268,0,0,0-.254,4.161c.007,8.629-.009,17.258.023,25.886,0,.861-.213,1.114-1.091,1.106q-7.257-.064-14.516,0c-.776.005-1-.2-1-.988q.031-25.626,0-51.251c0-.845.276-1.041,1.075-1.035q6.892.051,13.785,0c.846-.008,1.064.266,1.046,1.067C829.357,459.17,829.388,461.213,829.388,463.255Z",
    fill: "#6cd7bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_148",
    "data-name": "Path 148",
    d: "M803.068,482.779c0,8.452-.014,16.9.02,25.355,0,.939-.23,1.223-1.2,1.213-4.8-.053-9.6-.041-14.406-.007-.77.005-1-.187-1-.982q.035-25.668,0-51.336c0-.708.171-.961.923-.956,4.871.031,9.743.041,14.614-.006.936-.009,1.063.354,1.061,1.156Q803.048,470,803.068,482.779Z",
    fill: "#6cd7bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M804.392,439.108a9.592,9.592,0,1,1-9.576-9.542A9.624,9.624,0,0,1,804.392,439.108Z",
    fill: "#6cd7bb"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/Linkedin.cc978ff1134b2e6d2a6d79c3eef262b0.svg";
export { ForwardRef as ReactComponent };